import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const FolderIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.3"
        d="M3.50039 21H20.5004C21.3004 21 22.0004 20.3 22.0004 19.5V8.5C22.0004 7.7 21.3004 7 20.5004 7H10.0004L7.40039 4.39999C7.10039 4.09999 6.70039 4 6.30039 4H3.40039C2.60039 4 1.90039 4.7 1.90039 5.5V19.5C2.00039 20.3 2.70039 21 3.50039 21Z"
        {...svgAttrs}
      />
      <path opacity="0.3" d="M4 19L10 11L16 19H4Z" {...svgAttrs} />
      <path d="M11 19L15 14L19 19H11Z" {...svgAttrs} />
      <path
        opacity="0.3"
        d="M18 12C18.8 12 19.5 11.3 19.5 10.5C19.5 9.7 18.8 9 18 9C17.2 9 16.5 9.7 16.5 10.5C16.5 11.3 17.2 12 18 12Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default FolderIcon;
